export default __webpack_public_path__ + "static/media/rekognition-text-detection.62bac807.png";